import { render, staticRenderFns } from "./FinishBrakeMetals.vue?vue&type=template&id=6a184fdc&scoped=true&"
import script from "./FinishBrakeMetals.vue?vue&type=script&lang=js&"
export * from "./FinishBrakeMetals.vue?vue&type=script&lang=js&"
import style0 from "./FinishBrakeMetals.vue?vue&type=style&index=0&id=6a184fdc&prod&scoped=true&lang=css&"
import style1 from "./FinishBrakeMetals.vue?vue&type=style&index=1&id=6a184fdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a184fdc",
  null
  
)

export default component.exports